import PlainLoadingSpinner from 'components/PlainLoadingSpinner';
import { CheckoutComSourceFor3DS } from 'hooks/payment-3ds/useCheckoutCom3DSPayment';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useLoggedEffect } from 'hooks/useLoggedEffect';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Message } from 'semantic-ui-react';
import styles from './CheckoutComCheckoutWrapper.module.css';
import CheckoutComDropInCheckout from './CheckoutComDropInCheckout';

export const CheckoutComCheckoutWrapper = observer(() => {
  const router = useRouter();

  const {
    orderLoaded,
    orderId,
    isValid,
    haveValidPaymentSession,
    checkoutComPaymentSession,
    confirmed,
    orderError,
    navigateToCheckout,
    maybeContinueToPayment,
    currentPromo,
    initialised,
  } = useEnterStore();

  const { userInitialized: userStoreInitialised, currentUser } = useUserStore();

  useEffect(() => {
    (async () => {
      if (!isValid) {
        router.replace('/enternow/1');
      } else {
        if (userStoreInitialised && !currentUser) {
          await navigateToCheckout();
        }
      }
    })();
  }, [isValid, userStoreInitialised, currentUser, router]);

  useLoggedEffect(
    'CheckoutComCheckoutWrapper continue to payment',
    () => {
      if (!haveValidPaymentSession && isValid && currentUser && initialised) {
        maybeContinueToPayment();
      }
    },
    [
      haveValidPaymentSession,
      isValid,
      currentUser,
      orderId,
      currentPromo || false,
      initialised,
    ],
  );

  if (!isValid) {
    return <Message error>Order not valid</Message>;
  }
  if (!confirmed) {
    return <Message error>Order not confirmed</Message>;
  }

  if (!haveValidPaymentSession || !checkoutComPaymentSession) {
    return (
      <>
        {orderError && orderError.length > 0 && (
          <div className={styles.errorContainer}>
            <Message id="errorMessage" negative className={styles.errorMessage}>
              {orderError}
            </Message>
          </div>
        )}
        {(!orderError || orderError.length <= 0) && (
          <div className={styles.loadingSpinner}>
            <PlainLoadingSpinner />
          </div>
        )}
      </>
    );
  }

  return (
    <div className={styles.wrapper}>
      {orderError && orderError.length > 0 && (
        <div className={styles.errorContainer}>
          <Message id="errorMessage" negative className={styles.errorMessage}>
            {orderError}
          </Message>
        </div>
      )}

      {orderLoaded && (
        <CheckoutComDropInCheckout
          paymentSession={checkoutComPaymentSession.paymentSessionResponse}
          checkoutComPaymentSessionId={
            checkoutComPaymentSession.checkoutComPaymentSessionId
          }
          source={CheckoutComSourceFor3DS.ENTER}
        />
      )}
    </div>
  );
});
